import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import { EstadosInventarioFisicoConstant } from 'constants/index'

import * as ActivosFijosInventariosService from 'services/activosFijosInventarios.service'

import { ZrSwal } from 'utils'

const portletBreadcrumbs = [{ name: 'Activos Fijos' }, { name: 'Inventarios Físicos' }]

const tableHeaderRows = [
  { label: 'CÓDIGO', filter: { type: 'text', name: 'codigo' } },
  { label: 'TÍTULO', filter: { type: 'text', name: 'titulo' } },
  { label: 'OFICINA' },
  { label: 'RESPONSABLE' },
  { label: 'FEC INICIO' },
  { label: 'FEC FIN' },
  { label: 'TOT / ENC / NOE / DIF / DAÑ' },
  { label: 'ESTADO' },
  { label: '', width: 60 }
]

const ListaPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)
  const tablaRef = React.useRef(null)

  const clickNuevo = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_INVENTARIOS_NUEVO}`)
  }, [history])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_INVENTARIOS_EDITAR}/${_id}`)
    },
    [history]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      ZrSwal.showAlert({
        mensaje: '¿Seguro que desea eliminar el inventario?',
        tipo: 'error',
        onSuccess: () => {
          ActivosFijosInventariosService.eliminar(_id)
            .then(() => {
              __zariContext.snack('success', 'Registro eliminado!')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header
        title='Inventarios Físicos'
        breadcrumbs={portletBreadcrumbs}
        buttons={[{ name: 'Nuevo Inventario', onClick: clickNuevo }]}
      />
      <Portlet.Body>
        <Table.ServerSide
          useNest={true}
          ref={tablaRef}
          useFilters={true}
          url='/activos-fijos-inventarios-fisicos'
          headRows={tableHeaderRows}
          rowTemplate={row => (
            <Table.Row key={row._id}>
              <Table.Cell>{row.codigo || '--'}</Table.Cell>
              <Table.Cell>{row.titulo || '--'}</Table.Cell>
              <Table.Cell>{row.oficina || '--'}</Table.Cell>
              <Table.Cell>{row.responsableNombre || '--'}</Table.Cell>
              <Table.Cell>{row.fechaInicio || '--'}</Table.Cell>
              <Table.Cell>{row.fechaFin || '--'}</Table.Cell>
              <Table.Cell>
                {`${row.totalActivos || 0} / ${row.totalEncontrados || 0} / ${row.totalNoEncontrados || 0} / ${row.totalDiferentesUbicacion || 0} / ${row.totalDaniados || 0}`}
              </Table.Cell>
              <Table.Cell>
                {row.estado && EstadosInventarioFisicoConstant.__dictionary[row.estado]
                  ? EstadosInventarioFisicoConstant.__dictionary[row.estado].nombre
                  : '--'}
              </Table.Cell>
              <Table.Cell>
                <Table.Dropdown>
                  {({ handleClose }) => [
                    <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                      Ver / Editar
                    </Table.Dropdown.Item>,
                    <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                      Eliminar
                    </Table.Dropdown.Item>
                  ]}
                </Table.Dropdown>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ListaPage)
